@if (!isPluginMode()) {
  <mat-toolbar class="header">
    <div class="back" mat-dialog-close matTooltip="Atrás" matTooltipPosition="right">
      <mat-icon >arrow_back_ios_new</mat-icon>
    </div>
    <div>
    {{ data.title }}
    </div>
  </mat-toolbar>
}

<div [ngClass]="{'dialog-wrapper': !isPluginMode()}">
  <!--carga-->
  <div #wrapper>
    <form [formGroup]="form">
      @if (_enableDocumentSelection()) {
        <div class="form-row">
          <mat-checkbox
            [(ngModel)]="createFromDocumentMode"
            [ngModelOptions]="{standalone: true}"
            (ngModelChange)="toggleCreateFromDocumentMode($event)"
          > Crear a partir de un documento
          </mat-checkbox> 
        </div>
        @if (createFromDocumentMode()) {
          <div class="form-row">
            <mat-form-field class="field">
              <mat-label>Tipo de Documento Origen</mat-label>
              <mat-select formControlName="document_type">
                @for(sourceDocumentType of SOURCE_DOCUMENT_TYPES; track sourceDocumentType) {
                  <mat-option [value]="sourceDocumentType">
                    {{ sourceDocumentType | human }}
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
            @if (form.get('document_type').value) {
              <app-document-select
                formControlName="document_id"
                [documentType]="form.get('document_type').value"
                (onload)="onDocumentLoad($event)"
              >
              </app-document-select>
            }
          </div>
        }
      }
      <div class="form-row">
        <mat-form-field class="field">
          <mat-label>Bodega</mat-label>
          <mat-select formControlName="warehouse_id" required>
            @for (warehouse of warehouses$ | async; track warehouse.id) {
              <mat-option [value]="warehouse.id">
                {{ warehouse.name }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
        <ng-container formGroupName="extra_params">
          <mat-form-field class="field">
            <mat-label>Fecha de entrega requerida</mat-label>
            <input matInput [matDatepicker]="required_delivery_date" formControlName="required_delivery_date">
            <mat-datepicker-toggle matSuffix [for]="required_delivery_date"></mat-datepicker-toggle>
            <mat-datepicker #required_delivery_date [startAt]=""></mat-datepicker>
          </mat-form-field>
        </ng-container>
      </div>
      <div class="form-row">
        <mat-form-field class="field">
          <mat-label>Proveedor</mat-label>
          <mat-select formControlName="owner_id" multiple>
            <button type="button" mat-button (click)="addProvider()">Agregar Nuevo Proveedor</button>
            <mat-option selectAll [value]="null">Seleccionar Todos</mat-option>
            @for (provider of providers(); track provider.id) {
              <mat-option [value]="provider.id">
                {{ provider.name }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>

      @if (inventoriableCategoriesIds) {
        <div>
          <app-inventory-action-form
            [parentFormGroup]="(form | formGroup)"
            [enableDiscounts]="false"
            [enableAmount]="false"
            [filterCategories]="inventoriableCategoriesIds"
            [inventoryLayout]="true"
            [onlyInventoriable]="true"
            [showBuyPrice]="true"
            [showTotals]="false"
          >
          </app-inventory-action-form>
        </div>
      }
    </form>
  </div>
</div>

@if (!isPluginMode()) {
  <mat-toolbar class="footer">
    <button mat-raised-button mat-dialog-close> 
      Cancelar
    </button>
    <div class="expander"></div>
    <button mat-raised-button
            type="button"
            color="primary"
            [disabled]="!formValid || loading()"
            (click)="saveForm()">
      @if (loading()) {
        <mat-spinner diameter="30"></mat-spinner>
      } @else {
        Crear
      }      
    </button>
  </mat-toolbar>
}
